import { Controller } from '@hotwired/stimulus'

// Shared Badge controller (minimal placeholder)
// Attach to badge markup via `data-controller="badge"` for interactive behavior
export default class extends Controller {
  connect() {
    // no-op for now; reserved for future badge interactions (tooltips, a11y enhancements)
  }
}
